import * as React from 'react';
import { DisplayCodes, Permission, MeatballMenu, PromptConfirmationModal } from 'ui';
import styles from './compact-code-title-tile.scss';
import { TileProps } from 'ui/tile/tile';
import { debounceRender } from 'ui/common/debounce-render';

interface CompactCodeTitleTileProps extends TileProps {
  /**
   * @internal
   */
  childValues?: any;
}

export class CompactCodeTitleTileComponent extends React.PureComponent<CompactCodeTitleTileProps, any> {

  public static defaultProps: Partial<TileProps> = {
    enabledChildEntityOperations: { remove: false }
  };

  private handleDelete = (e?: any) => {
    const { onDeleteDocumentItem } = this.props;
    
    e && e.preventDefault();
    onDeleteDocumentItem && onDeleteDocumentItem();
    this.forceUpdate();
  };

  public render() {
    const {
      componentId,
      primaryKey,
      children,
      showPrimaryKey = true
    } = this.props;

    const { controlLabel, compactCodeTile, withMeatballMenu } = styles;
    const removableFieldStyles = this.shouldRenderContextMenu() ? withMeatballMenu : '';

    return (
      <div id={componentId} className={`className ${compactCodeTile} ${removableFieldStyles}`}>
        {showPrimaryKey && <DisplayCodes
          componentId={`${componentId}-code`}
          className={controlLabel}
          valueItems={[primaryKey]}
          displayIcon={'left'}
          options={undefined}
          onChange={undefined}
        />}
        {this.renderContextMenu()}
        {children}
      </div>
    );
  }

  private shouldRenderContextMenu = () => {
    const { enabledChildEntityOperations, childValues } = this.props;

    if(!!childValues && !childValues?.[childValues?.length-1]?.value) {
      return false;
    }

    return enabledChildEntityOperations && Object.keys(enabledChildEntityOperations)
      .reduce((acc, key) => acc || enabledChildEntityOperations[key], false);
  };

  // TODO: Move this (and the copy in CodeTitleTile) to a shared enhancer.
  private renderContextMenu() {

    if  (!this.shouldRenderContextMenu()) {
      return undefined;
    }

    const { enabledChildEntityOperations, textDelete, textDeleteMessage, textContinue, textCancel } = this.props;

    return (
      <Permission requireAny="remove" permissions={enabledChildEntityOperations}>
        <div className={styles.tileDropdown}>
          <MeatballMenu>
              <Permission requireAll="remove" permissions={enabledChildEntityOperations} isListElement={true}>
                <PromptConfirmationModal
                  title={textDelete}
                  description={textDeleteMessage}
                  continueText={textContinue}
                  cancelText={textCancel}
                  onContinue={this.handleDelete}>
                  <button type="button" className="dropdown-item">{textDelete}</button>
                </PromptConfirmationModal>
              </Permission>
          </MeatballMenu>
        </div>
      </Permission>
    );
  }
}

const t = debounceRender(CompactCodeTitleTileComponent);
export {t as CompactCodeTitleTile};
